<template name="component-name">
  <div>
    <mt-swipe :auto="4000" class="g-banner">
      <mt-swipe-item class="banner_image" v-for="(item,index) in formatBanners" :key="index">
        <router-link v-if="item.url.indexOf('https://')===-1" :to="{ path: item.url }">
          <img :src="item.image_url" class="slide-image" />
        </router-link>
        <a v-else :href="item.url">
        <img :src="item.image_url" class="slide-image" />
        </a>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      swiperList: [],
    };
  },
  computed: {
       ...mapGetters(['isLogin']),
        formatBanners() {
      return this.swiperList.filter((ele) =>
        this.isLogin ? ele.is_need_login !== 2 : ele.is_need_login !== 1
      );
    },
  },
  created() {
    this.getSwiper();
  },
  methods: {
    getSwiper() {
      this.$get({
        road: 'advertisement',
        query: { type: 2, pageSize: 100, },
      }).then(res => {
        if (res.code === 0) {
          // this.nologin_swiperList = res.data.list;
          this.swiperList = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.g-banner {
  width: 100%;
  height: 240px;
}

.banner_image {
  width: 100%;
  height: 240px;
  overflow: hidden;
  border-radius: 20px;
}

.slide-image {
  width: 100%;
  height: 100%;
}
</style>
